import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";

import IndexView from "./Index/View";
import PreviewPenilaianView from "./PreviewPenilaian/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  // const _uuid = queryParams.get("uuid");
  const _preview_penilaian = queryParams.get("preview_assestment");
  if (_preview_penilaian != null) {
    return accessRole("update") ? <PreviewPenilaianView /> : <ErrorAccess />;
  }
  return accessRole("read") ? <IndexView /> : <ErrorAccess />;
};
export default RouteView;
